import store from 'state/RootReducer';
import { RestEnds } from '../Constants';
import axios, { CanceledError } from 'axios';
import { PublicActions } from 'state/public/Action';

const GuestAxiosManager = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const getAccessToken = (): string => store.getState().publicState.accessToken;
const getRefreshToken = (): string => store.getState().publicState.refreshToken;

/**
 *  Used to modify the request headers common for all requests
 */
GuestAxiosManager.interceptors.request.use((configInfo: any) => {
  const config = configInfo;
  // Append auth header
  if (
    config.headers['append-auth-header'] === 'true' &&
    getAccessToken() !== ''
  ) {
    config.headers['x-auth-token'] = `bearer ${getAccessToken()}`;
  }
  return config;
});

// To refresh accessToken and retry failed requests
let isAlreadyFetchingAccessToken = false;
let subscribers: any[] = [];
const onAccessTokenFetched = (accessToken: string): void => {
  subscribers = subscribers.filter((callback) => callback(accessToken));
};

const addSubscriber = (callback: any): void => {
  subscribers.push(callback);
};

const logout = (): void => {
  store.dispatch(PublicActions.doLogout({}));
};

// Function that will be called to refresh authorization
export const refreshAccessToken = (): any =>
  GuestAxiosManager.post(
    RestEnds.REFRESH_TOKEN,
    {},
    {
      headers: {
        'x-auth-token': `bearer ${getRefreshToken()}`,
      },
    }
  )
    .then((response: any) => {
      const { accessToken, refreshToken } = response.data.data;
      store.dispatch(
        PublicActions.setLoginStatus({ accessToken, refreshToken })
      );
      isAlreadyFetchingAccessToken = false;
      onAccessTokenFetched(accessToken);
    })
    .catch(() => {
      isAlreadyFetchingAccessToken = false;
      subscribers = [];
      logout();
    });

// AxiosManager.interceptors.request.use((response) => response);

GuestAxiosManager.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error instanceof CanceledError === false) {
      const {
        config,
        response: { status },
      } = error;
      const originalRequest = config;
      if (
        status === 401 &&
        config.url !== RestEnds.REFRESH_TOKEN &&
        config.url !== RestEnds.LOGOUT &&
        config.url !== RestEnds.LOGIN
      ) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true;
          return new Promise((resolve) => {
            addSubscriber((accessToken: string) => {
              originalRequest.headers['x-auth-token'] = `bearer ${accessToken}`;
              resolve(GuestAxiosManager(originalRequest));
            });
            refreshAccessToken();
          });
        }
        // exclusion
        return new Promise((resolve) => {
          addSubscriber((accessToken: string) => {
            originalRequest.headers['x-auth-token'] = `bearer ${accessToken}`;
            resolve(GuestAxiosManager(originalRequest));
          });
        });
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const { CancelToken: cancelation, Cancel } = axios;

export const CancelToken = cancelation;
export const CancelStatic = Cancel;

export default GuestAxiosManager;
